import React from 'react';

const MovePlayer = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 200 200"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.5,
        }}
        {...props}
    >
        <g clipPath="url(#_clip1)">
            <g transform="matrix(3.01325,0,0,2.91007,-3584.86,-353.075)">
                <g>
                    <g transform="matrix(0.898807,0,0,1.08957,128.63,-4.41302)">
                        <path d="M1185,174L1233,133" strokeWidth="2.54" fill="none" />
                    </g>
                    <g transform="matrix(0.568556,0.568556,-0.747307,0.747307,637.521,-675.865)">
                        <path d="M1245,131L1260,148L1230,148L1245,131Z" />
                    </g>
                </g>
            </g>
        </g>
        <clipPath id="_clip1">
            <rect x="0" y="0" width="200" height="200" />
        </clipPath>
    </svg>
);

export default MovePlayer;
